import styled from '@emotion/styled';

const TitleH1 = styled.h1`
  color: ${(props) => (props.color ? props.color : '#183066')};
  font-family: Arial;
  font-size: 3rem;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 3.75rem;
  margin: 0;
`;

const TitleH2 = styled.h2`
  color: ${(props) => (props.color ? props.color : '#183066')};
  font-size: 2rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 3.75rem;
  margin: 0;

  @media only screen and (max-width: 768px) {
    line-height: 2rem;
    margin: 1.5rem 0;
  }
`;

const TitleH3 = styled.h3`
  color: ${(props) => (props.color ? props.color : '#183066')};
  font-family: Arial;
  font-size: 1.625rem;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 2.0625rem;
  display: inline-block;
  text-transform: uppercase;
  margin: 0;
`;

export { TitleH1, TitleH2, TitleH3 };
